import React from 'react';

function SignatureSection({
  typedName,
  typedTemplates,
  typedSelectedTemplate,
  onNameChange,
  onTemplateSelect,
  signaturePosition,
  hasSignatureImage,
  onPlaceSignature,
  onResetSignature,
}) {
  const maxNameLength = 22;

  return (
    <div>
      <h3 className="text-sm font-semibold text-gray-900 mb-4">Add Your Signature</h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-900 mb-2">
          Type your full name
        </label>
        <input
          data-tour="signature-name-input"
          type="text"
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors mb-3"
          value={typedName}
          maxLength={maxNameLength}
          onChange={(e) => onNameChange(e.target.value.slice(0, maxNameLength))}
          onFocus={(e) => {
            // Select all text when focused, so user can easily replace "test" demo value
            if (e.target.value === 'test') {
              e.target.select();
            }
          }}
          placeholder="Enter your legal name"
        />
        {typedName.length >= maxNameLength && (
          <p className="text-xs text-amber-600 mb-3">
            Maximum {maxNameLength} characters.
          </p>
        )}
        {!typedName.trim() ? (
          <p className="text-xs text-gray-500 mb-3">
            Enter your name to generate signature templates.
          </p>
        ) : (
          <p className="text-xs text-gray-600 mb-3">
            Select a signature style below. You can change it anytime.
          </p>
        )}
        {typedName.trim() ? (
          <>
            <div data-tour="signature-templates" className="grid grid-cols-1 2xl:grid-cols-2 gap-3 mb-4">
              {typedTemplates.map((template) => {
                const isActive = template.key === typedSelectedTemplate;
                return (
                  <button
                    type="button"
                    key={template.key}
                    onClick={() => onTemplateSelect(template.key)}
                    className={`p-3 border-2 rounded-lg transition-all ${
                      isActive
                        ? 'border-blue-500 bg-blue-50 shadow-sm'
                        : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
                    }`}
                  >
                    <img
                      src={template.image}
                      alt={template.label}
                      className="w-full h-auto mb-2"
                    />
                    <div className="flex items-center justify-between">
                      <p className="text-xs font-medium text-gray-700">{template.label}</p>
                      {isActive && (
                        <svg
                          className="w-4 h-4 text-blue-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      )}
                    </div>
                  </button>
                );
              })}
            </div>
            {hasSignatureImage && (
              <div className="mt-4 pt-4 border-t border-gray-200">
                <div className="mb-3">
                  <span className="text-sm font-semibold text-gray-900">Place Signature</span>
                </div>
                <div className="flex gap-2">
                  <button
                    data-tour="place-signature-button"
                    onClick={onPlaceSignature}
                    disabled={signaturePosition}
                    className="flex-1 px-4 py-2.5 bg-blue-500 text-white text-sm font-medium rounded-md hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:text-gray-500 transition-colors flex items-center justify-center gap-2"
                    title={signaturePosition ? 'Already placed - use Undo to remove' : ''}
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                      />
                    </svg>
                    {signaturePosition ? 'Signature Placed' : 'Place Signature'}
                  </button>
                  <button
                    onClick={onResetSignature}
                    disabled={!signaturePosition}
                    className="px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-1.5"
                    title={signaturePosition ? 'Undo signature placement' : ''}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
                    </svg>
                    Undo
                  </button>
                </div>
              </div>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
}

export default SignatureSection;
